<template>
  <div>
    <Header></Header>
    <div class='join'>
      <div class='join-input'><input v-on:input="change" id='search' type='text' placeholder='请输入您的意向加盟城市'><i class='icon'></i></div>
    </div>
<!--    <Footer></Footer>-->
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'JoinQuery',
  components: {Header, Footer},
  data () {
    return {
      msg: 'JoinQuery',
      search: ''
    }
  },
  methods: {
    change: function () {
      self.search = document.getElementById('search')
      // console.log(self.search.value)
      window.open('https://www.sharkpark.cn/partner/searchList/?key=' + self.search.value)
    }
  }
}
</script>
<style>
  .join{
    width: 100%;
    height: 34em;
    line-height: 27em;
    background-image: url('../assets/img/joinQuery/banner.jpg');
    text-align:center;
  }
  .join-input input{
    width: 60em;
    height: 5em;
    border-radius: 0.3em;
    font-size:1em;
  }
  .icon{
    width:5em;
    height:5em;
    /*margin-left:-5em;*/
    /*margin-bottom:-2em;*/
    /*background-image: url('../assets/img/joinQuery/search.jpg');*/
    background:black;
  }
</style>
